/** Matches EnvironmentVariablesInline — dynamic extraction vars are not managed on the Environments page. */
export function isDynamicExtractionVariable(v: {
  extractFromResponse?: boolean;
  extractJsonPath?: string | null;
  extractHeaderName?: string | null;
}): boolean {
  return (
    v.extractFromResponse === true ||
    !!(v.extractJsonPath && String(v.extractJsonPath).trim()) ||
    !!(v.extractHeaderName && String(v.extractHeaderName).trim())
  );
}

export function isManageableProjectScopedVariable(v: {
  scope?: unknown;
  deleted?: boolean | null;
  extractFromResponse?: boolean;
  extractJsonPath?: string | null;
  extractHeaderName?: string | null;
}): boolean {
  const rawScope = String(v.scope ?? '').trim().toLowerCase().replace(/_/g, '-');
  if (rawScope !== 'project') return false;
  if (v.deleted === true) return false;
  return !isDynamicExtractionVariable(v);
}

export function countManageableProjectScopedVariables(
  variables: ReadonlyArray<{
    scope?: unknown;
    deleted?: boolean | null;
    extractFromResponse?: boolean;
    extractJsonPath?: string | null;
    extractHeaderName?: string | null;
  }> | null | undefined
): number {
  return (variables ?? []).filter(isManageableProjectScopedVariable).length;
}
